import { render, staticRenderFns } from "./GeneHome.vue?vue&type=template&id=29e95231&scoped=true&"
import script from "./GeneHome.vue?vue&type=script&lang=js&"
export * from "./GeneHome.vue?vue&type=script&lang=js&"
import style0 from "./GeneHome.vue?vue&type=style&index=0&id=29e95231&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e95231",
  null
  
)

export default component.exports